export default __webpack_public_path__ + "static/media/invoice_1.99f33aac.PNG";